let $ = require('jquery');
let Backbone = require("backbone");

let main = function(Backbone){
    return Backbone.View.extend({
        pagingControl: null,

        events: {
        },

        /**
         * pagingControl is optional, if supplied this view, will help you disable button when necessary
         * (for example at page 0, the prev button should be disabled) and
         * show current / total page information
         * @param params
         */
        initialize: function(params) {
            this.listenTo(this.model, 'change:currentPage', this.showPage);
            this.listenTo(this.model, 'change:itemSize', this.pageUpdate);

            if(params.pagingControl) {
                this.pagingControl = params.pagingControl;
                var self = this;

                this.listenTo(this.model, 'change:currentPage', function(m, page) {
                    self.pagingControl.find('.pageUp').attr('disabled', page==0 ? 'disabled' : null);
                    self.pagingControl.find('.pageDown').attr('disabled', page==m.get('maxPage')-1 ? 'disabled' : null);
                });

                this.pagingControl.find('.pageUp').click(function() {
                    self.pageUp();
                });

                this.pagingControl.find('.pageDown').click(function() {
                    self.pageDown();
                });
            }
        },
            
        render: function() {
            this.model.set({currentPage:0});

            if(this.pagingControl) {
                if(this.model.get('maxPage')>1) {
                    this.pagingControl.find('.pageInfo').text('1/'+this.model.get('maxPage'));
                    this.pagingControl.removeClass('hidden');
                    this.pagingControl.find('.pageUp').attr('disabled', this.model.get('currentPage')==0 ? 'disabled' : null);
                    this.pagingControl.find('.pageDown').attr('disabled', this.model.get('currentPage')==this.model.get('maxPage')-1 ? 'disabled' : null);
                } else {
                    this.pagingControl.addClass('hidden');
                }
            }

            return this;
        },

        pageUp: function() {
            this.model.pageUp();
        },

        pageDown: function() {
            this.model.pageDown();
        },

        toLastPage: function() {
            this.model.toLastPage();
        },

        showPage: function(model, pageNumber) {
            var start = pageNumber*this.model.get('pageSize'), end = start + this.model.get('pageSize')-1;

            this.$('.pitem').each(function(i, ele) {
                if(i>=start && i<=end) {
                    $(ele).removeClass('hidden');
                } else {
                    $(ele).addClass('hidden');
                }
            });

            if(this.pagingControl) {
                this.pagingControl.find('.pageInfo').text((pageNumber+1) + '/' + this.model.get('maxPage'));
            }
        },

        pageUpdate: function(model) {
            model.set({maxPage: Math.ceil(model.get("itemSize")/model.get('pageSize'))});
            this.showPage(model, 0);
        }
    });
};

let exportedValue = main(Backbone);
module.exports = exportedValue;


// WEBPACK FOOTER //
// ./src/view/comp/PagingView.js